import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaWhatsapp, FaSnapchatGhost, FaPhone, FaGlobe, FaMapMarkerAlt } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import { contactInfo } from '../../utils/whatsapp';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          {/* Company Info */}
          <div className="footer-section">
            <h3 className="footer-logo">نمو ماركتينج</h3>
            <p className="footer-description">
              وكالة تسويق رقمي متخصصة في تصميم المواقع، إدارة السوشيال ميديا، والإعلانات الممولة.
              نساعدك تنمّي مشروعك وتحقق أهدافك الرقمية.
            </p>
            <div className="social-icons">
              <a
                href={contactInfo.socialLinks.facebook}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="social-icon facebook"
              >
                <FaFacebookF />
              </a>
              <a
                href={contactInfo.socialLinks.instagram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="social-icon instagram"
              >
                <FaInstagram />
              </a>
              <a
                href={contactInfo.socialLinks.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                className="social-icon whatsapp"
              >
                <FaWhatsapp />
              </a>
              <a
                href={contactInfo.socialLinks.snapchat}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Snapchat"
                className="social-icon snapchat"
              >
                <FaSnapchatGhost />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-title">روابط سريعة</h4>
            <ul className="footer-links">
              <li>
                <Link to="/">الرئيسية</Link>
              </li>
              <li>
                <Link to="/about">من نحن</Link>
              </li>
              <li>
                <Link to="/services">الخدمات</Link>
              </li>
              <li>
                <Link to="/contact">اتصل بنا</Link>
              </li>
            </ul>
          </div>

          {/* Our Services */}
          <div className="footer-section">
            <h4 className="footer-title">خدماتنا</h4>
            <ul className="footer-links">
              <li>
                <Link to="/services/web-design">تصميم المواقع</Link>
              </li>
              <li>
                <Link to="/services/social-media">إدارة السوشيال ميديا</Link>
              </li>
              <li>
                <Link to="/services/paid-ads">الإعلانات الممولة</Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4 className="footer-title">تواصل معنا</h4>
            <ul className="footer-contact">
              <li>
                <MdEmail className="contact-icon" />
                <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
              </li>
              <li>
                <FaPhone className="contact-icon" />
                <a href={`https://wa.me/${contactInfo.phoneInternational}`}>
                  {contactInfo.phoneDisplay}
                </a>
              </li>
              <li>
                <FaGlobe className="contact-icon" />
                <span>{contactInfo.website}</span>
              </li>
              
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p className="copyright">
            © {currentYear} نمو ماركتينج. جميع الحقوق محفوظة.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
